// cr 主頁 section2 item

const CRAboutItem = ({num, info}) =>{
    return(
        <>
            <p className="text-bd6n pointer-events-none">
                <span className="text-title text-red0 mr-[8.5px]">0{num}.</span>
                {info?.title}
            </p>
            <p className="text-red0 text-bd2n pointer-events-none">{info?.subtitle}</p>
            <div>
                <p className="text-bd1m text-justify pointer-events-none">{info?.content}</p>
            </div>
        </>
    )

};

export default CRAboutItem ;